<template>
  <div class="text-right">
    <a
      class="link-download"
      @click="DownloadFromUrl('/document/Niveles_catering.pdf','Niveles.pdf')"
      >¿Cómo se calcula tu nivel de Menú Diario?</a
    >
  </div>
</template>
<script>
export default {
  methods: {
    DownloadFromUrl(fileURL, fileName) {
      var link = document.createElement("a");
      link.href = window.location.origin + fileURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>
